import script from "./PortfolioDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioDetails.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioDetails.vue?vue&type=style&index=0&id=409e5ca0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-409e5ca0"]])

export default __exports__